import { ValueFormatterParams } from "ag-grid-community";
import moment, { Moment } from "moment";

/** This is a column definition of the grid on Anchor page */
export function formatDate(dateString: string | any) {
  console.log("DATE FORMAT", dateString);
  if (dateString.result) {
    console.log("here1");
    return moment(dateString.result).format("DD/MM/YYYY");
  }
  console.log("here2");
  return moment(dateString).format("DD/MM/YYYY");
}
export function formatDateToTime(dateString: string | Date) {
  return moment(dateString).format("DD/MM/YYYY HH:mm:ss");
}
interface DateFormats {
  "DD/MM/YYYY": "DD/MM/YYYY"; // 25/10/2023
  "MMMM Do YYYY, h:mm:ss a": ""; // October 25th 2023, 2:41:57 pm
  dddd: "dddd"; // Wednesday
  "MMM Do YY": "MMM Do YY"; // Oct 25th 23
  "YYYY [escaped] YYYY": ""; // 2023 escaped 2023
}

const DateFormat: DateFormats & { [k: OtherFormat]: string } = {
  "DD/MM/YYYY": "DD/MM/YYYY",
  "MMMM Do YYYY, h:mm:ss a": "",
  dddd: "dddd",
  "MMM Do YY": "MMM Do YY",
  "YYYY [escaped] YYYY": "",
} as const;

type OtherFormat = string & NonNullable<unknown>;

/**
 *
 * @param {moment.MomentInput} dateString
 * @param {keyof typeof DateFormat} [format="DD/MM/YYYY"] default `DD/MM/YYYY`
 * @param {string} [customDefaultFormatSeparator="/"] default `/`
 * @param {boolean} [returnObject=false] if true retuns `moment object`
 *
 * some of the supported formats:
 * - `DD/MM/YYYY`, --- `October 25th 2023, 12:00:00 pm`
 * - `MMMM Do YYYY, h:mm:ss a` --- `October 25th 2023, 12:00:00 pm`
 * - `dddd` --- `Wednesday`
 * - `MMM Do YY` --- `Oct 25th 23`
 * - `YYYY [escaped] YYYY` --- `2023 escaped 2023`
 *
 *  find more formats at: https://momentjs.com/docs/#/displaying/
 */
export default function FormatDate(
  dateString: moment.MomentInput,
  format: keyof typeof DateFormat = "DD/MM/YYYY",
  customDefaultFormatSeparator = "",
  returnObject = false
) {
  const sep = customDefaultFormatSeparator;
  if (returnObject) return moment(dateString);
  else if (customDefaultFormatSeparator) return moment(dateString).format(`DD${sep}MM${sep}YYYY`);
  return moment(dateString).format(format as string);
}

// /**
//  * return full name of the user
//  * @param   {string} firstName  First Name of the User
//  * @param   {string} lastName   Last Name of the User
//  * @return  {string}            Fullname of the user
//  */

export function dateValueFormatter(params: ValueFormatterParams) {
  return formatDate(params.value);
}

export function DateDifference(date1: Moment, date2: Moment, unit: moment.unitOfTime.Diff, precise = false) {
  return date1.diff(date2, unit, precise);
}
